import React, { useState, useEffect  } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, ModalBody, Button } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

import backlogo from '../../Assets/App_icon/back.png';
import excellogo from '../../Assets/App_icon/excel.png';


const ProductMaster = () => {
  
  const store = localStorage.getItem('store');
  const host_url = localStorage.getItem('host_url');
  const userRole = localStorage.getItem('userRole');

  const navigate = useNavigate();
  const [modalVisible, setModalVisible] = useState(false); 
  const [plgModalVisible, setPlgModalVisible] = useState(false);

  const [catlist, setCatlist] = useState([]);
  const [prdlist, setPrdlist] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState('');
  const [stockLedger, setStockLedger] = useState([]);

  const [ledgerFromDate, setLedgerFromDate] = useState('');
  const [ledgerToDate, setLedgerToDate] = useState('');
  const [ledgerPartyFilter, setLedgerPartyFilter] = useState('');



  const handleBack = () => {
    navigate('../dashboard');
  };

    useEffect(() => {
      document.title = "Stock Report";
    }, []); // for Title Set

    // Escape key press handling
    useEffect(() => {
      const handleKeyPress = (event) => {
        if (event.key === "Escape") {
          if (modalVisible || plgModalVisible) {
            if (modalVisible ) {
              setModalVisible(false);
            }
            if (plgModalVisible ) {
              setPlgModalVisible(false);
            }
          } else {
            handleBack();
          }
        }
      };

      document.addEventListener("keydown", handleKeyPress);
      return () => {
        document.removeEventListener("keydown", handleKeyPress);
      };
    }, [modalVisible, plgModalVisible]); 

    useEffect(() => { 
      const fetchCatagoryList = async () => { 
          const formData = new FormData();
          formData.append("type", "list");
          formData.append("store", store);
          formData.append("catlist", '');

          try {
            const response = await fetch(`${host_url}/category_mlist`, {
              method: 'POST',
              body: formData,
            });
            
            const data = await response.json();
            setCatlist(data);
          } catch (error) {
            console.error('Error fetching categories:', error);
          }
      }; 
     fetchCatagoryList(); 
    }, [host_url]); // Categoty Fetch 

    useEffect(() => { 
      const fetchCatagoryList = async () => { 
          try {
            const response = await fetch(`${host_url}/stock`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
                'userid': localStorage.getItem('userid'),
              },
              body: JSON.stringify({
                type: 'list',
                store: store,
                purdetail: 'null',
              }),
            });

            if (response.status === 401) {
              localStorage.clear();
              alert('Your account has been disabled.');
              window.location.href = "/";
              return;
            }

            const data = await response.json();
            setPrdlist(data);
          } catch (error) {
            console.error('Error fetching categories:', error);
          }
      }; 
     fetchCatagoryList(); 
    }, [host_url]); // Product Fetch

    const [prdNameFilter, setPrdNameFilter] = useState('');
    const [prdEnameFilter, setPrdEnameFilter] = useState('');
    const [catEnameFilter, setCatEnameFilter] = useState('');
    const [stockFilter, setStockFilter] = useState('');
    const [stockAmtFilter, setStockAmtFilter] = useState('');

    const filteredPrdlist = prdlist.filter(prd =>
      prd.prd_name.toLowerCase().includes(prdNameFilter.toLowerCase()) &&
      prd.prd_Ename.toLowerCase().includes(prdEnameFilter.toLowerCase()) && 
      String(prd.pcat_id).toLowerCase().includes(catEnameFilter.toLowerCase()) && 
      (stockFilter === "" ||  (stockFilter === "Minus" && prd.prd_stock < 0) || (stockFilter === "Plus" && prd.prd_stock > 0)) &&
      (stockAmtFilter === "" ||  (stockAmtFilter === "Minus" && prd.prd_stock_amt < 0) || (stockAmtFilter === "Plus" && prd.prd_stock_amt > 0))
    );

    const totalCount = filteredPrdlist.length;
    const totalprd_stock_amt = filteredPrdlist.reduce((sum, row) => sum + Number(row.prd_stock_amt), 0);


    const filteredLedger = stockLedger.filter(item => {
      const itemDate = new Date(item.report_date).toLocaleDateString('en-CA');

      const matchDate =
        (!ledgerFromDate || itemDate >= ledgerFromDate) &&
        (!ledgerToDate || itemDate <= ledgerToDate);

      const matchParty =
        (item.party_name || '')
          .toLowerCase()
          .includes(ledgerPartyFilter.toLowerCase());

      return matchDate && matchParty;
    });

    
    const exportToExcel = async () => {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Stock Report');

      // Define headers
        worksheet.columns = [
          { header: 'Category', key: 'Category', width: 20 },
          { header: 'G_Name', key: 'G_Name', width: 30 },
          { header: 'After_Order', key: 'After_Order', width: 15 },
          { header: 'Stock', key: 'Stock', width: 15 },
        ];

      // Add rows
        filteredPrdlist.forEach(item => {
          worksheet.addRow({
            Category: item.pcat_Ename,
            G_Name: item.prd_name,
            After_Order: item.ord_qty,
            Stock: item.prd_stock,
          });
        });


      // Apply borders to all cells in the worksheet
        worksheet.eachRow((row, rowNumber) => {
          row.height = 35;
          row.alignment = {vertical: 'middle'};
          row.eachCell(cell => {
            cell.border = {
              top:    { style: 'dotted' },
              left:   { style: 'dotted' },
              bottom: { style: 'dotted' },
              right:  { style: 'dotted' },
            };
          });
        });

      // ✅ Right-align "After_Order" and "Stock" columns
        worksheet.eachRow((row, rowNumber) => {
          if (rowNumber === 1) return; // Skip header row

          // After_Order = column 3, Stock = column 4 (1-based indexing)
          row.getCell(3).alignment = { vertical: 'middle', horizontal: 'right' };
          row.getCell(4).alignment = { vertical: 'middle', horizontal: 'right' };
        });

      // Apply header styles
        worksheet.getRow(1).eachCell(cell => {
          cell.font = { bold: true };
          cell.alignment = { vertical: 'middle', horizontal: 'center' };
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFEFEFEF' }
          };
        });

      // Write to file
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, 'StockReport.xlsx');
    };

    const handleStockUpdate = async () => {
      setModalVisible(false); 
      const prdupdateDetail = {
            prd_id: selectedProduct.prd_id,
            prd_stock: selectedProduct.prd_stock,
            prd_stock_amt: selectedProduct.prd_stock_amt,
        };

      try {
        // console.log(prdupdateDetail);
        
        const response = await fetch(`${host_url}/stock`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            type: 'Update', 
            store: store, 
            prddetail: prdupdateDetail, 
          }),
        });
        const data = await response.json();
        setPrdlist(data);
        
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

    const handleStockLedger = async () => {
      setModalVisible(false); 

      // Today date
      const today = new Date();
      const sdate = today.toISOString().split('T')[0];
      
      // Current month 1st date
      const pastDate = new Date(today);
      pastDate.setMonth(today.getMonth());
      pastDate.setDate(1);
      const edate = pastDate.toISOString().split('T')[0]

      const prdupdateDetail = {
            type: 'List', 
            prd_id: selectedProduct.prd_id,
            sdate: sdate,
            edate: edate,
        };

      try {
         
        
        const response = await fetch(`${host_url}/stock_ledger`, {
          method: 'POST', 
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            store: store, 
            detail: prdupdateDetail, 
          }),
        });
        const data = await response.json();
        setStockLedger(data);        
        setPlgModalVisible(true);
        setLedgerFromDate(edate);
        setLedgerToDate(sdate);

       
        
      } catch (error) {
        console.error('Error fetching cities:', error);
      }
    };

    const handlePrdDetail = async (row) => {
      setModalVisible(true);
      setSelectedProduct(row);
      console.log(row);
    };

  return (
    <div className="container">
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <div onClick={handleBack}>
                <img src={backlogo} alt="Back" className='system-icon'/>
              </div>
              <b style={{ margin: '10px', fontSize: '20px' }}>Stock Report</b>
              <div >
                <div onClick={exportToExcel}>
                  <img src={excellogo} alt="Back" className='system-icon'/>
                </div>
              </div>
          </div> 
        
          <table className="table-bordered table-sm custom-hover">
            <thead>
              <tr >
                <th colSpan='2'>Category</th>
                <th colSpan='2'>E_Name</th>
                <th colSpan='2'>G_Name</th>
                <th>Stock</th>
                <th>Amount</th>
              </tr>
              <tr>
                <th colSpan='2'>
                  <select
                    className="search-input"
                    value={catEnameFilter}
                    onChange={(e) => setCatEnameFilter(e.target.value)}
                  >
                    <option value="">All Category</option>
                    {catlist.map((catlist) => (
                      catlist.pcat_count > 0 && (
                        <option key={catlist.pcat_Id} value={catlist.pcat_id}>
                          {catlist.pcat_Ename}
                        </option>
                      )
                    ))}
                  </select>
                </th>
                <th colSpan='2'>
                  <input
                    type="text"
                    className="search-input"
                    value={prdEnameFilter}
                    onChange={(e) => setPrdEnameFilter(e.target.value)}
                  />
                </th>
                <th colSpan='2'>
                  <input
                    type="text"
                    className="search-input"
                    value={prdNameFilter}
                    onChange={(e) => setPrdNameFilter(e.target.value)}
                  />
                </th>   
                <th>
                  <select
                    className="search-input"
                    value={stockFilter}
                    onChange={(e) => setStockFilter(e.target.value)}
                  >
                    <option value="">All Status</option>
                    <option value="Minus">Minus</option>
                    <option value="Plus">Plus</option>
                  </select>  
                </th>
                <th>
                  <select
                    className="search-input"
                    value={stockAmtFilter}
                    onChange={(e) => setStockAmtFilter(e.target.value)}
                  >
                    <option value="">All Status</option>
                    <option value="Minus">Minus</option>
                    <option value="Plus">Plus</option>
                  </select> 
                </th>
              </tr>
            </thead>
            <tbody className="scrollable-body">
              {filteredPrdlist.map((row, index) => {
                  return (
                    <tr key={index} style={{ lineHeight: '10px', fontSize:'14px' }} >
                      <td className="cell-left" colSpan="2"><span style={{ paddingLeft: '10px' }}>{row.pcat_Ename}</span></td>
                      <td className="cell-left" colSpan="2">{row.prd_Ename}</td>
                      <td className="cell-left" colSpan="2">{row.prd_name}</td>
                      <td className="cell-right" style={{ color: row.prd_stock < 0 ? 'red' : 'inherit', cursor: userRole === 'Admin' ? 'pointer' : 'default' }} onClick={userRole === 'Admin' ? () => handlePrdDetail(row) : undefined} >{row.prd_stock == 0 ? '' : row.prd_stock } </td>
                      <td className="cell-right" style={{ color: row.prd_stock_amt < 0 ? 'red' : 'inherit' }} onClick={userRole === 'Admin' ? () => handlePrdDetail(row) : undefined} >{row.prd_stock == 0 ? '' : row.prd_stock_amt } </td>
                    </tr>
                  );
              })}
            </tbody>
            <tfoot>
              <tr >
                <th className="cell-left" colSpan='2'><span style={{ paddingLeft: '10px' }}>{totalCount}</span></th>
                <th className="cell-left" colSpan='2'><span style={{ paddingLeft: '10px' }}></span></th>
                <th className="cell-left" colSpan='2'><span style={{ paddingLeft: '10px' }}></span></th>
                <th className="cell-right"><span style={{ paddingRight: '15px' }}></span></th>
                <th className="cell-right"><span style={{ paddingRight: '5px' }}>{totalprd_stock_amt}</span></th>
              </tr>
            </tfoot>
          </table>


          {/* Modal for Stock Detail */}
            <Modal isOpen={modalVisible} toggle={() => setModalVisible(!modalVisible)} className="detailmodal" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}> 
                  <div >
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%' }}>
                      <tbody>
                        <tr>
                          <td>Name</td>
                          <td className="cell-left" style={{ padding: '5px' }} >{selectedProduct.prd_name}</td>  
                        </tr>
                        <tr>
                          <td>Stock Qty</td>
                          <td style={{ padding: '2px' }} >
                            <input
                              type="text"
                              value={selectedProduct.prd_stock}
                              onChange={(e) => setSelectedProduct({ ...selectedProduct, prd_stock: e.target.value })}
                            />
                          </td>  
                        </tr>
                        <tr>
                          <td>Stock Amt</td>
                          <td style={{ padding: '2px' }} >
                            <input
                              type="text"
                              value={selectedProduct.prd_stock_amt}
                              onChange={(e) => setSelectedProduct({ ...selectedProduct, prd_stock_amt: e.target.value })}
                            />
                          </td>    
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Button color="warning" style={{ flex: 1, marginRight: '10px' }} onClick={handleStockLedger} >
                      Stock Ledger 
                    </Button>
                    <Button color="success" style={{ flex: 1, marginRight: '10px' }} onClick={handleStockUpdate} >
                      Stock Update 
                    </Button>
                    <Button color="primary" style={{ flex: 1 }} onClick={() => setModalVisible(false)}>
                      Close
                    </Button>
                  </div>
                
              </ModalBody>
            </Modal>        


          {/* Modal for Stock Ledger */}
            <Modal isOpen={plgModalVisible} toggle={() => setPlgModalVisible(!plgModalVisible)} className="detailmodal-lg" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}> 
                  <div style={{ marginTop: '5px' }}>
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      
                      <thead >
                        <tr >
                          <th colSpan="2" style={{ fontWeight: '500' }} >
                              <input
                                type="date"
                                className="search-input  no-icon" style={{ textAlign: 'center' }}
                                value={ledgerFromDate}
                                onChange={(e) => setLedgerFromDate(e.target.value)}
                              />
                          </th>
                          <th colSpan="3" ><span style={{ fontWeight: '700', color: 'blue'}}>{selectedProduct.prd_name}</span></th>

                          <th colSpan="2" style={{ fontWeight: '500' }} >Sales</th>
                          <th colSpan="2" style={{ fontWeight: '500' }}>Purchase</th>
                          <th colSpan="2" style={{ fontWeight: '500' }}>wastage</th>
                        </tr>

                        <tr>
                          <th colSpan="2" style={{ fontWeight: '500' }}>
                              <input
                                type="date"
                                className="search-input  no-icon" style={{ textAlign: 'center' }}
                                value={ledgerToDate}
                                onChange={(e) => setLedgerToDate(e.target.value)}
                              />
                          </th>
                          <th colSpan="3" style={{ fontWeight: '500' }} >
                              <input
                                type="text"
                                className="search-input"
                                placeholder="Search Party"
                                value={ledgerPartyFilter}
                                onChange={(e) => setLedgerPartyFilter(e.target.value)}
                              />
                          </th>

                          <th style={{ fontWeight: '500' }} >Qty</th>
                          <th style={{ fontWeight: '500' }} >Amt</th>
                          <th style={{ fontWeight: '500' }} >Qty</th>
                          <th style={{ fontWeight: '500' }} >Amt</th>
                          <th style={{ fontWeight: '500' }} >Qty</th>
                          <th style={{ fontWeight: '500' }} >Amt</th>

                          
                        </tr>
                      </thead>

                      <tbody className="scrollable-body">
                        {filteredLedger.map((item, index) => (
                          <tr key={index} style={{ lineHeight: '10px', fontSize: '14px' }}>

                            <td colSpan="2" className="cell-center" >
                              {new Date(item.report_date).toLocaleDateString('en-GB')}
                            </td>

                            <td colSpan="3" className="cell-left" >
                              {item.party_name || ''}
                            </td>

                            {/* Sale */}
                            <td className="cell-right">
                              {item.entry_type === 'Sale' ? item.qty : ''}
                            </td>

                            <td className="cell-right">
                              {item.entry_type === 'Sale' ? item.amt : ''}
                            </td>

                            {/* Purchase */}
                            <td className="cell-right">
                              {item.entry_type === 'Purchase' ? item.qty : ''}
                            </td>

                            <td className="cell-right">
                              {item.entry_type === 'Purchase' ? item.amt : ''}
                            </td>

                            {/* Waste */}
                            <td className="cell-right">
                              {item.entry_type === 'Waste' ? item.qty : ''}
                            </td>

                            <td className="cell-right">
                              {item.entry_type === 'Waste' ? item.amt : ''}
                            </td>

                          </tr>
                        ))}
                      </tbody>

                      <tfoot>
                        <tr>
                          <th colSpan="2" className="cell-left" style={{ padding: '2px' }}>
                            <Button color="primary" style={{ padding: '2px', margin: '2px' }} onClick={() => setPlgModalVisible(false)}>
                              Close
                            </Button>
                          </th>

                          <th colSpan="3" className="cell-right" style={{ fontWeight: '500' }} >Total</th>

                          {/* Sale Total */}
                          <th className="cell-right" style={{ fontWeight: '500' }} >
                            {
                              filteredLedger
                                .filter(x => x.entry_type === 'Sale')
                                .reduce((a, b) => a + Number(b.qty), 0)
                                .toFixed(3)
                            }
                          </th>

                          <th className="cell-right" style={{ fontWeight: '500' }} >
                            {
                              filteredLedger
                                .filter(x => x.entry_type === 'Sale')
                                .reduce((a, b) => a + Number(b.amt), 0)
                            }
                          </th>

                          {/* Purchase Total */}
                          <th className="cell-right" style={{ fontWeight: '500' }} >
                            {
                              filteredLedger
                                .filter(x => x.entry_type === 'Purchase')
                                .reduce((a, b) => a + Number(b.qty), 0)
                                .toFixed(3)
                            }
                          </th>

                          <th className="cell-right" style={{ fontWeight: '500' }} >
                            {
                              filteredLedger
                                .filter(x => x.entry_type === 'Purchase')
                                .reduce((a, b) => a + Number(b.amt), 0)
                            }
                          </th>

                          {/* Waste Total */}
                          <th className="cell-right"style={{ fontWeight: '500' }} >
                            {
                              filteredLedger
                                .filter(x => x.entry_type === 'Waste')
                                .reduce((a, b) => a + Number(b.qty), 0)
                                .toFixed(3)
                            }
                          </th>

                          <th className="cell-right" style={{ fontWeight: '500' }} >
                            {
                              filteredLedger
                                .filter(x => x.entry_type === 'Waste')
                                .reduce((a, b) => a + Number(b.amt), 0)
                            }
                          </th>

                        </tr>
                      </tfoot>

                    </table>
                  </div>    

              </ModalBody>
            </Modal>          
        
    </div>
  );
};

export default ProductMaster;
